import moment from 'moment';
import map from 'lodash/map';
import lodash from 'lodash';
window.lodash = lodash;
window.moment = moment;

Date.prototype.getWeek = function () {
    let date = new Date(this.getTime());
    date.setHours(0, 0, 0, 0);
    // Thursday in current week decides the year.
    date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
    // January 4 is always in week 1.
    let week1 = new Date(date.getFullYear(), 0, 4);
    // Adjust to Thursday in week 1 and count number of weeks from date to week1.
    return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
};

Date.prototype.isSameDateAs = function (pDate) {
    return (
        this.getFullYear() === pDate.getFullYear() &&
        this.getMonth() === pDate.getMonth() &&
        this.getDate() === pDate.getDate()
    );
};

const ChartDataTransformer = {

    getDateRangeOfWeek: (weekNo, year, startDate, endDate) => {

        const d1 = ChartDataTransformer.getDateOfWeek(weekNo, year);

        const rangeIsFrom = `${eval(d1.getMonth() + 1)}/${d1.getDate()}/${d1.getFullYear()}`;

        d1.setDate(d1.getDate() + 6);

        const rangeIsTo = `${eval(d1.getMonth() + 1)}/${d1.getDate()}/${d1.getFullYear()}`;

        const startDateWeekNumber = moment(startDate).week();

        return `${rangeIsFrom} to ${rangeIsTo}`;

    },

    getDateOfWeek: (w, y) => {
        let d = (1 + (w-1) * 7);
        return new Date(y, 0, d);
    },

    getDateOfWeekAndYear: (weekNo, year) => {
        let d1 = ChartDataTransformer.getDateOfWeek(weekNo, year);
        return d1;
    },

    transform: (usersData, metricesMap, searchObject) => {
        console.log(usersData, searchObject)
        
    if(usersData && usersData.length>0){

        let startDateWeekNumber = moment(searchObject.startDate).week()==0?
        moment(searchObject.startDate).week():moment(searchObject.startDate).week()-1;

        

        let startDateWeekYear = moment(searchObject.startDate).year();

        const tempStartYear = startDateWeekYear;
        
        let endDateWeekNumber = new Date(searchObject.endDate).getWeek();

        const colors = ['#1EC4B4', '#F06292', '#5099DE', '#F2994A', '#BB6BD9', '#4E5E7C', '#874B60', '#FF0000', '#33FF00'];

        const endDateWeekYear = moment(searchObject.endDate).year();

        console.log('s0---', startDateWeekYear)

        const startMonth = new Date(searchObject.startDate).getMonth();

        const endMonth = new Date(searchObject.endDate).getMonth();

        const weekNumbers = [];

        const weekYears = [];

        let weekDelta = moment(searchObject.endDate).diff(moment(searchObject.startDate), 'week') +2

        let sDate = startDateWeekYear
        while (sDate <= endDateWeekYear) {
            weekYears.push(sDate++);
        }

        let x =0;

        for (x=0; x < weekYears.length; x++) {
                let firstYear = weekYears[x];
    
                let initWeek = startDateWeekNumber
                let delta_ct = 0 
                let finalWeek = endDateWeekNumber
      
                if(firstYear > weekYears[0]){
                    console.log('final--', )
                    initWeek=0
                    finalWeek = 52
                    if(weekYears.indexOf(firstYear)===weekYears.length-1){
                        finalWeek=endDateWeekNumber
                    } 
                } 
                else if (firstYear<endDateWeekYear){
                    finalWeek=52
                }

                console.log(firstYear,initWeek,endDateWeekNumber,finalWeek)

                while (initWeek <=finalWeek  ) {
                    weekNumbers.push({
                        week: initWeek,
                        year: firstYear,
                    });
                    initWeek++
                }
            }
        
       
        let counter = -1;      
        const LineChartData = usersData ? map(searchObject.metrics, (i) => {
            counter++;
            const xData = [];
            const yData = [];
            const textData = [];
            let rollingValue=[]
            const item = usersData.map(y => y.metrics[`${metricesMap.filter(u => u.id === i)[0].id}`]);
            console.log('----',weekNumbers)
            for (const week of weekNumbers) {
                // console.log('week----',week)

                const rangeValue = ChartDataTransformer.getDateOfWeekAndYear(week.week, week.year);
                xData.push(rangeValue.toISOString());
                // console.log('x--', xData)

                const tempArray = [];

                for (const metricItem of item) {
                    if (metricItem && metricItem.length > 0) {
                        for (const metric of metricItem) {
                            // console.log('metric--', metric)

                            if (moment(metric.createdDate).isoWeek() === week.week && metric.year === week.year) {
                                rollingValue.push(metric)
                            }
                        }
                    }
                }
                yData.push(rollingValue.length);
                textData.push(`Date: ${ChartDataTransformer.getDateRangeOfWeek(week.week, week.year, searchObject.startDate, searchObject.endDate)} count : ${rollingValue.length}`);
            }
            return {
                x: xData,
                y: yData,
                type: 'line',
                line: colors[counter],
                marker: {
                    color: colors[counter],
                    symbol: metricesMap.length > 0 && metricesMap.filter(u => u.id === i)[0].symbol,
                },
                name: metricesMap.length > 0 && metricesMap.filter(u => u.id === i)[0].name,
                text: textData,
                hoverinfo: 'text',
                showlegend: true,
            };
        }) : null;
        
        return LineChartData;
    }
    },
};

export default ChartDataTransformer;
